var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8131 0H6.18204C2.77275 0 0 2.77275 0 6.18204V12.7161V15.1224V25.818C0 29.2272 2.77275 32 6.18204 32H25.8131C29.2224 32 32 29.2272 32 25.818V15.1224V12.7161V6.18204C32 2.77275 29.2224 0 25.8131 0ZM27.5877 3.68897L28.2917 3.68415V4.38819V9.10428L22.8861 9.12357L22.8716 3.70344L27.5877 3.68897ZM11.4334 12.7161C12.4605 11.2984 14.1193 10.3677 16 10.3677C17.8806 10.3677 19.5395 11.2984 20.5666 12.7161C20.692 12.8897 20.8029 13.0681 20.9042 13.2514C21.3623 14.0663 21.6323 15.0018 21.6323 15.9952C21.6323 19.1007 19.1055 21.6275 16 21.6275C12.8945 21.6275 10.3677 19.1007 10.3677 15.9952C10.3677 14.997 10.6377 14.0615 11.0958 13.2465C11.1971 13.0681 11.308 12.8849 11.4334 12.7161ZM28.88 25.8131C28.88 27.5057 27.5057 28.88 25.8131 28.88H6.18204C4.48945 28.88 3.11513 27.5057 3.11513 25.8131V14.3749V12.7161H7.88909C7.76854 13.0102 7.66727 13.3092 7.58047 13.6178C7.36348 14.3749 7.24774 15.1706 7.24774 16C7.24774 20.8222 11.173 24.7523 15.9952 24.7523C20.8174 24.7523 24.7426 20.827 24.7426 16C24.7426 15.1754 24.6221 14.3749 24.4051 13.6178C24.3183 13.3092 24.217 13.0102 24.0964 12.7161H28.8752V14.3749V25.8131H28.88Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramFilled);
export default __webpack_public_path__ + "static/media/instagram_filled.fb6028c9fa78d95877030b8e59739aa8.svg";
export { ForwardRef as ReactComponent };